import { render, staticRenderFns } from "./VxeToolTipSpan.vue?vue&type=template&id=63e08a16&scoped=true"
import script from "./VxeToolTipSpan.vue?vue&type=script&lang=js"
export * from "./VxeToolTipSpan.vue?vue&type=script&lang=js"
import style0 from "./VxeToolTipSpan.vue?vue&type=style&index=0&id=63e08a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e08a16",
  null
  
)

export default component.exports